import React, { useContext, useEffect, useRef, useState, useCallback } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HomeIcon from "@mui/icons-material/Home";
import { useHistory, useParams } from "react-router-dom";
import {
  Box,
  CircularProgress,
  Typography,
} from "@mui/material";
import "./CategoryDetails.css";
import ProductCard from "../../components/ProductCard";
import useBusinessQuery from "../../store/Bussiness/useBusinessQuery";
import { variableContext } from "../../context/VariableContex";
import BookmarkNotFound from "../myListing/bookmark/bookmarkNotFound/BookmarkNotFound";
import useCommonQuery from "../../store/common/useCommonQuery";
import ShareIcon from "@mui/icons-material/Share";
import LayoutToggle from "../../components/LayoutToggle/LayoutToggle";
import "../../page-header-controls.css";


function CategoryDetails() {
  const { locationData } = useContext(variableContext);

  const history = useHistory();

  const inputRef = useRef();

  const params = useParams();

  const [value, setValue] = useState("");
  const [search, setSearch] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [subCategoryName, setSubCategoryName] = useState("");
  const [items, setItems] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [height, setHeight] = useState("");

  const { data: categoryList } = useCommonQuery.Get_category({
    search: "",
    limit: 20,
    offset: 0
  });

  const { data: subcategoryList } = useCommonQuery.Get_subcategory({
    id: params?.id || "",
    search: "",
    limit: 20,
    offset: 0,
  });

  const handleChange = (e) => {
    setValue(e.target.value);
    if (e.target.value == "location") {
      history.push("/location-search");
    }
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };
  const query = {
    latitude: locationData?.latitude,
    longitude: locationData?.longitude,
    radius: locationData?.radius || 10,
    category: params?.id || "",
    subCategory: params.name ? params?.name : "",
    name: search,
    limit: 25,
    offset: (currentPage - 1) * 25,
  };

  const {
    data: list,
    refetch,
    isLoading,
  } = useBusinessQuery.Get_bussiness_list(query);

  useEffect(() => {
    if (categoryList && params?.id) {
      setCategoryName(
        categoryList?.data?.results?.find((item) => item.id == params?.id)?.name
      );
    } else {
      if (!params?.id && subcategoryList) {
        setCategoryName(
          subcategoryList?.data?.results?.find(
            (item) => item.id == params?.name
          )?.category_name
        );
      }
    }
  }, [subcategoryList, categoryList]);

  useEffect(() => {
    if (subcategoryList && params?.name) {
      setSubCategoryName(
        subcategoryList?.data?.results?.find((item) => item.id == params?.name)?.name
      );
    }
  }, [subcategoryList, params]);


  const handleShare = async () => {

    try {
      await navigator.share({
        url: window.location.href,
      });
    } catch (error) { }
  };


  useEffect(() => {
    refetch();
  }, [currentPage, search, locationData]);


  useEffect(() => {
    if (list) {
      // API returns { results: [...], count: N } directly (bussinessUrl returns data?.data)
      const results = list?.results || list?.data?.results || list?.data || [];

      if (currentPage === 1) {
        setItems([...results]);
      } else {
        setItems(prev => [...prev, ...results]);
      }

      setLoading(false);
    }
  }, [list, currentPage]);

  const handleScroll = useCallback(() => {
    if (loading || isLoading) return;

    const results = list?.results || list?.data?.results || list?.data || [];
    if (items.length > 0 && results.length < 25) return;
    if (items.length > 0 && items.length % 25 !== 0) return;

    const scrollElement = inputRef.current;
    if (scrollElement) {
      const { scrollTop, scrollHeight, clientHeight } = scrollElement;
      if (scrollTop + clientHeight >= scrollHeight - 100) {
        setLoading(true);
        setCurrentPage(prev => prev + 1);
      }
    }
  }, [currentPage, loading, isLoading, items.length, list]);

  useEffect(() => {
    const scrollElement = inputRef.current;
    if (scrollElement) {
      scrollElement.addEventListener("scroll", handleScroll);
      return () => scrollElement.removeEventListener("scroll", handleScroll);
    }
  }, [handleScroll]);


  return (
    <div ref={inputRef} className="cat-details-root">

      {/* ── Sticky header ── */}
      <div className="phc-bar">
        <div className="phc-inner" style={{ position: "relative" }}>

          {/* ── Page title: shown on both mobile and desktop ── */}
          {(subCategoryName || categoryName) && (
            <div className="phc-title-row">
              <span className="phc-page-title">{subCategoryName || categoryName}</span>
            </div>
          )}

          {/* ── MOBILE header: title row + controls row ── */}
          <div className="cd-mob-row">

            {/* Centered page title */}
            {(subCategoryName || categoryName) && (
              <span className="cd-mob-title">{subCategoryName || categoryName}</span>
            )}

            {/* Controls: back | home | search input+btn | toggle | share */}
            <div className="cd-mob-controls">

              <button className="cd-mob-back" onClick={() => history.goBack()}>
                <svg className="cd-mob-arrow" viewBox="0 0 10 16" fill="currentColor">
                  <path d="M8.5 1L1.5 8l7 7" stroke="currentColor" strokeWidth="2"
                    strokeLinecap="round" strokeLinejoin="round" fill="none" />
                </svg>
                <span className="cd-mob-back-label">{categoryName}</span>
              </button>

              <button className="phc-home-btn" onClick={() => history.push("/")}>
                <HomeIcon className="phc-home-btn-icon" />
                <span className="phc-home-btn-label">Home</span>
              </button>

              <div className="cd-mob-search" style={{ maxWidth: 150 }}>
                <input
                  className="cd-mob-search-input"
                  type="text"
                  placeholder="Search"
                  value={search}
                  onChange={handleSearch}
                />
                <button className="cd-mob-search-btn">Search</button>
              </div>

              <LayoutToggle size="sm" />

              <div className="phc-share-btn" onClick={handleShare}>
                <ShareIcon />
              </div>

            </div>
          </div>

          {/* ── DESKTOP header row (unchanged) ── */}
          <div className="cd-desk-row phc-row">

            <div className="phc-back" onClick={() => history.goBack()}>
              <ArrowBackIcon className="phc-back-icon" />
              <span className="phc-back-label">{categoryName}</span>
            </div>

            <button className="phc-home-btn" onClick={() => history.push("/")}>
              <HomeIcon className="phc-home-btn-icon" />
              <span className="phc-home-btn-label">Home</span>
            </button>

            <Typography className="phc-title">{subCategoryName}</Typography>

            <div className="phc-spacer" />

            <div className="phc-search-wrap">
              <input
                className="phc-search-input"
                type="text"
                placeholder="Search"
                value={search}
                onChange={handleSearch}
              />
              <button className="phc-search-btn">Search</button>
            </div>

            <LayoutToggle size="sm" />

            <div className="phc-share-btn" onClick={handleShare}>
              <ShareIcon />
            </div>

          </div>

        </div>
      </div>
      {/* end sticky header */}

      {/* ── Product grid body ── */}
      <div className="cat-details-body">
        {isLoading && items.length === 0 ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 8 }}>
            <CircularProgress />
          </Box>
        ) : items?.length === 0 ? (
          <BookmarkNotFound title={"No items"} />
        ) : (
          <div className="cat-details-grid">
            {items.map((card, i) => <ProductCard item={card} key={i} wideButtons />)}
          </div>
        )}

        {/* Pagination loading indicator */}
        {loading && !isLoading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 2, mb: 3 }}>
            <CircularProgress size={24} />
            <Typography variant="body2" sx={{ ml: 2 }}>Loading more...</Typography>
          </Box>
        )}
      </div>
      {/* end body */}

    </div>
  );
}

export default React.memo(CategoryDetails);
